<template>
  <main class="relative z-10 w-full py-5 md:py-16">
    <Carousel />
    <a
      :href="$GetColumn('home_ad_link')"
      class="relative z-10 block w-full px-5 py-10 mx-auto max-w-7xl md:py-20"
    >
      <img
        :src="$ImageUrl($GetColumn('home_ad_image_lg'))"
        class="hidden w-full md:block"
      />
      <img
        :src="$ImageUrl($GetColumn('home_ad_image_sm'))"
        class="block w-full md:hidden"
      />
    </a>
    <ProductList :product_data="promote_product_data" title="" />
    <NewsList />
  </main>
</template>

<script>
import Carousel from "@/components/home/Carousel.vue";
import ProductList from "@/components/home/ProductList.vue";
import NewsList from "@/components/home/NewsList.vue";

export default {
  name: "HomeView",
  components: {
    Carousel,
    ProductList,
    NewsList,
  },
  methods: {
    async getPageData() {
      let data_param_list = {};

      data_param_list = this.checkThemeColumn(data_param_list);
      data_param_list = this.checkNewsData(data_param_list);
      data_param_list = this.checkProductData(data_param_list);

      if (Object.keys(data_param_list).length > 0) {
        await this.$store.dispatch("getPageData", data_param_list);
      }

      this.$nextTick(() => {
        this.$PageInit(this, "");
      });
    },
    checkThemeColumn(data_param_list) {
      let tmp_data_param_list = { ...data_param_list };
      const home_column = this.$store.state.common_column_data.find(
        (item) => item.Title == "home_ad_image_lg"
      );
      if (home_column == null) {
        tmp_data_param_list.theme_columns = ["home"];
      }

      if (this.$store.state.carousel_data == null) {
        tmp_data_param_list.carousels = {};
      }

      return tmp_data_param_list;
    },
    checkNewsData(data_param_list) {
      let tmp_data_param_list = { ...data_param_list };
      const news_data = this.$store.state.news_data;

      if (news_data == null) {
        tmp_data_param_list.news_list = { page: 1, perPage: 3 };
      } else if (
        news_data.Page != 1 ||
        news_data.PerPage != 3 ||
        news_data.CategoryId != "" ||
        news_data.Keyword != "" ||
        news_data.Sort != ""
      ) {
        tmp_data_param_list.news_list = { page: 1, perPage: 3 };
      }

      return tmp_data_param_list;
    },
    checkProductData(data_param_list) {
      let tmp_data_param_list = { ...data_param_list };
      const product_data = this.$store.state.product_data;

      if (product_data == null) {
        tmp_data_param_list.product_list = [
          {
            page: 1,
            perPage: 8,
            categoryId: 7,
            eventProduct: "Y",
          },
        ];
      } else if (
        product_data.Page != 1 ||
        product_data.PerPage != 8 ||
        product_data.CategoryId != 7 ||
        product_data.EventProduct != "Y"
      ) {
        tmp_data_param_list.product_list = [
          {
            page: 1,
            perPage: 8,
            categoryId: 7,
            eventProduct: "Y",
          },
        ];
      }

      return tmp_data_param_list;
    },
  },
  computed: {
    promote_product_data() {
      if (this.$store.state.product_data == null) {
        return [];
      }
      return this.$store.state.product_data.List;
    },
  },
  created() {
    this.getPageData();
  },
};
</script>
